/*
 * is-valid-json : A small tool to check if a Javscript literal/object is JSON or not
 *
 * Copyright(c) 2016 - Shubham Oli <oli.shubham@gmail.com>
 *
 * License - MIT
 */

module.exports = require('./is-valid-json.js');